import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import '../styles/blog-post.styles.scss'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Seo from "../components/seo";
import AllPostsButton from "../components/AllPostsButton";
import { BsMailbox } from 'react-icons/bs'
import { AiOutlineCheck } from 'react-icons/ai'
import axios from 'axios'

export default ({ data }) => {

  console.log({
    data
  })

  const post = data.markdownRemark

  const postCategory = data.markdownRemark.frontmatter.category
  const postTitle = data.markdownRemark.frontmatter.title

  const [subscribedSuccess, setSubscribedSuccess] = useState(false);
  const [subscribedError, setSubscribedError] = useState('');
  const [newsLetterEmail, setNewsLetterEmail] = useState('');


  const handleNewsLetterEmail = (value) => {
    setNewsLetterEmail(value);
  }

  const subscribeToNewsLetter = async () => {

    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g
    if (!regex.test(newsLetterEmail)) return setSubscribedError('Por favor informe um endereço de e-mail válido')


    const data = new FormData();
    data.append('email', newsLetterEmail)


    const request = await fetch(`https://hooklab.com.br/pt-br/http/save-email.php`, {
      method: 'POST',
      body: data
    })

    const response = await request.json()
    if (response.http_code == '200') {

      await axios.post(`https://www.rdstation.com.br/api/1.3/form-integrations`,
        {
          email: newsLetterEmail,
          token_rdstation: "7f09339e93ab595d0fcbb0495c57608a",
          form_url: "https://hooklab.com.br/blog",
          page_title: "Hooklab | Blog",
          identificador: "assinou o newsletter"
        }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      setSubscribedSuccess(true);
    } else {
      setSubscribedError(response.message)
    }
  }

  return (
    <Layout>
      <Seo
        title={post.frontmatter.title}
        description={post.frontmatter.description}
      />
      <div className='post-banner'>
        <div className='post-image'>
          <GatsbyImage image={getImage(post.frontmatter.image)} alt={post.frontmatter.title} />
        </div>

      </div>
      <div className='container'>
        <div className='post-page-container'>
          <div className='post-page-wrapper'>
            <h1 className='post-page-title'>{post.frontmatter.title}</h1>
            <p className='post-page-date'>{post.frontmatter.date}</p>
            <p className='post-page-description'>{post.frontmatter.description}</p>
            <div className='post-page-text' dangerouslySetInnerHTML={{ __html: post.html }} />
            <div className='subscribe-newsletter-container'>
              {subscribedSuccess ?

                <div style={{ textAlign: 'center' }}>
                  <div>
                    <AiOutlineCheck size={36} />
                  </div>
                  <div>
                    <h3>Você se inscreveu no nosso newsletter! <br />Muito obrigado!</h3>
                  </div>
                </div>
                :
                <>
                  <div style={{ textAlign: 'center' }}>
                    <BsMailbox size={42} />
                  </div>
                  <div>
                    <h2>Receba nossos conteúdos!</h2>
                  </div>
                  <div className="newsletter-text">
                    <span>Você vai receber em primeira mão e-books, blogs e relatórios da Hooklab no seu e-mail!</span>
                  </div>
                  <div className="input-area">
                    <input value={newsLetterEmail} onChange={e => handleNewsLetterEmail(e.target.value)} type='text' placeholder="O seu endereço de e-mail" />
                    <button onClick={subscribeToNewsLetter}>Assinar</button>
                  </div>
                  <div className="newsletter-privacy">
                    Ao assinar o newsletter, você aceita a nossa <a href='https://hooklab.com.br/privacidade'>política de privacidade</a>
                  </div>

                  {subscribedError.length > 0 && <div className="newsletter-error">{subscribedError}</div>}

                </>}
            </div>
            <div className='post-line'></div>
            <div className='post-bottom'>
              <img className='author-picture' src={post.frontmatter.authorPic} />
              <div className='author-info'>
                <span><small>Escrito por</small></span>
                <span><b>{post.frontmatter.author}</b></span>
                <p>{post.frontmatter.authorInfo}</p>
              </div>
            </div>
          </div>
          <div className='sidebar-container'>
            <div className='post-sidebar-container'>
              <span>Veja também</span>
              <div className='post-line'></div>
              {
                data.allMarkdownRemark.edges.map(({ node }) => {
                  return node.frontmatter.category === postCategory && node.frontmatter.title != postTitle ?
                    <Link className='post-sidebar-wrapper' to={`/${node.frontmatter.postUrl}`} key={node.id}>
                      <h3 className='post-sidebar-title'>{node.frontmatter.title}</h3>
                      <p className='post-sidebar-description'>{node.frontmatter.description.substring(0, 150)}...</p>
                    </Link>
                    :
                    null
                })
              }
              <AllPostsButton />
            </div>

          </div>
        </div>
      </div>
    </Layout >
  )
}


export const query = graphql`
  query($slug: String!) {
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            id
            title
            description
            postUrl
            category
          }
        }
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        author
        authorInfo
        authorPic
        title
        description
        category
        date
        postUrl
        
        image {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              transformOptions: {cropFocus: CENTER}
              width: 2500
              height: 500
            )
          }
        }
      }
    }
  }
`;
